module.exports = __webpack_public_path__ + "img/icon_plus_24.3cd2e25e.svg";